import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";

const CategoryList = ({ allCategories }) => {
    const { t } = useTranslation(["blog"]);
    const router = useRouter();
    const [showCategories, setShowCategories] = useState(false);
    const isFullSlug = allCategories.some((category) => category?.slug?.startsWith('/blog'));
    return (
        <div className="p-3 mx-2 mt-8 bg-white rounded-lg lg:p-6 lg:my-0 lg:mx-0">
            {allCategories.length > 0 && <h5 className="flex justify-between text-xl font-semibold" onClick={() => setShowCategories(!showCategories)}>
                <div className="flex items-center space-x-2">
                    <i className="text-2xl lg:hidden ri-price-tag-3-fill"></i>
                    <span> {t("blog:categories")}</span>
                </div>
                <i className={`ri-arrow-${showCategories ? 'up' : 'down'}-s-line duration-500 lg:hidden`} ></i>
            </h5>}

            {/* Kategori Listesi */}
            <div className={`lg:block ${showCategories ? "block" : "hidden"}`}>
                {allCategories.slice(0, 10).map((category, index) => (
                    <Link
                        href={isFullSlug ? `${category?.slug}` : `/${router.locale}/blog/${category?.slug}`}
                        // href={`blog/${category?.slug}`} 
                        key={index}>
                        <div className={`flex items-center justify-between py-4  cursor-pointer border-buttonBg ${index === allCategories.length - 1 ? '' : 'border-b lg:border-b-2'}`}>
                            <p className="text-sm font-medium text-textGray">{category?.title}</p>
                            <p className="flex justify-center items-center p-4 w-6 h-6 text-black rounded-full lg:text-textGray bg-buttonBg lg:bg-makdosYellow">
                                {category?.article_count}
                            </p>
                        </div>
                    </Link>
                ))}
            </div>

            {allCategories.length > 10 && <div className="py-4 mt-5 w-full rounded-full cursor-pointer text-textGray bg-buttonBg">
                <p className="flex justify-center items-center"> {t("blog:allCategories")}</p>
            </div>}
        </div>
    )
}

export default CategoryList